export default __webpack_public_path__ + "static/media/guided-histories-icon.3d8184f9.svg";